import { customEvent } from '@core/customEvent/customEvent'
import { EventTypeReady } from '@core/customEvent/eventTypeReady'

import type { Ifwn } from './types'

/**
 *
 */
export function init(cb: () => void) {
  if (typeof window !== 'undefined' && !window._fwn) {
    window['_fwn'] = {} as Ifwn
  }

  window._fwn.version = process.env.RELEASE_VERSION ?? 'unknown'

  cb()
  customEvent({
    target: null,
    type: EventTypeReady.FW_READY,
    data: {},
  })
}
